import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent } from '@ionic/react'
import ModalHeader from '../ModalHeader'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  isOpen: boolean;
  title?: string;
  children: any;
  reject?: () => void;
}

const DetailModal: FC<IProps> = (props: IProps) => {
  const { title, isOpen, children, reject } = props
  return (
    <IonModal
      cssClass='mkt-detail-modal'
      isOpen={isOpen}
      showBackdrop
      backdropDismiss
      onDidDismiss={reject}
    >
      <ModalHeader title={title || i18n.t('cart.details')} onClose={reject}></ModalHeader>
      <IonContent className='modal-content'>
        <div className='content-body'>
          {children}
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(DetailModal)
